import Uuid from "./utils/uuid.js";

class FrameCommRouter {
	/**
	 * @param {string} key
	 */
	// @ts-expect-error TS(7006) FIXME: Parameter 'key' implicitly has an 'any' type.
	constructor(key) {
		// A unique key makes sure message-passing is isolated
		(this as any).key = key;
		(this as any).handlers = [];

		window.addEventListener("message", (evt) => {
			const msg = evt.data;
			if (msg.type === "FrameCommRouterMsg") {
				this._deliverMsg(msg);
				this._relayMsg(msg);
			}
		});
	}

	/**
	 * Register a handler function to be called when
	 * a message is received for the frame with the
	 * specified name. The returned value can be used
	 * to de-register the handler.
	 *
	 * @param {string}   frameName
	 * @param {function} handler
	 * @return {string}
	 */
	// @ts-expect-error TS(7006) FIXME: Parameter 'frameName' implicitly has an 'any' type... Remove this comment to see the full error message
	registerFrameHandler(frameName, handler) {
		const id = Uuid.base64();
		(this as any).handlers.push({
			id,
			frameName,
			handler
		});

		return id;
	}

	/**
	 * @param {string}
	 */
	// @ts-expect-error TS(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
	deregisterHandler(id) {
		let found = false;
		// @ts-expect-error TS(7006) FIXME: Parameter 'h' implicitly has an 'any' type.
		(this as any).handlers = (this as any).handlers.filter((h) => {
			if (h.id === id) {
				found = true;
				return false;
			} else
				return true;
		});

		return found;
	}

	/**
	 * Send a message to the specified destination frame.
	 *
	 * @param {string} dest
	 * @param {Object} msg
	 */
	// @ts-expect-error TS(7006) FIXME: Parameter 'dest' implicitly has an 'any' type.
	send(dest, msg) {
		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		window.top.postMessage({
			type:             "FrameCommRouterMsg",
			key:              (this as any).key,
			destinationFrame: dest,
			msg
		}, "*");
	}

	/**
	 * @param {Object} wrappedMsg
	 * @param {string} wrappedMsg.type
	 * @param {string} wrappedMsg.destinationFrame
	 * @param {Object} wrappedMsg.msg
	 */
	// @ts-expect-error TS(7006) FIXME: Parameter 'wrappedMsg' implicitly has an 'any' typ... Remove this comment to see the full error message
	_deliverMsg(wrappedMsg) {
		const {destinationFrame, msg} = wrappedMsg;
		// @ts-expect-error TS(7006) FIXME: Parameter 'h' implicitly has an 'any' type.
		(this as any).handlers.filter((h) => (h.frameName === destinationFrame)).forEach(h => {
			h.handler(msg);
		});
	}

	/**
	 * Relay a message (evt.data) to child iframes.
	 * @param {Object} msg
	 */
	// @ts-expect-error TS(7006) FIXME: Parameter 'msg' implicitly has an 'any' type.
	_relayMsg(msg) {
		// Relay the message to iframes within iframes
		// eslint-disable-next-line @typescript-eslint/prefer-for-of
		for (let i = 0; i < window.frames.length; i++)
			window.frames[i].postMessage(msg, "*");
	}
}

export default FrameCommRouter;
